import { BUTTON_ACTIVE_BACKGROUND_COLOR_TRELLIS } from './constants/quickFilterButtonProperties';
import { RemoveIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuickFilterSelectBase = ({
  button,
  buttonHeight,
  isActive,
  onValueChange,
  propertyName
}) => {
  return /*#__PURE__*/_jsxs(View, {
    "data-selenium-test": `QuickFiltersBar-item-${propertyName}`,
    as: "div",
    blockSize: `${buttonHeight}px`,
    display: "inline-block",
    borderRadius: "100",
    backgroundColor: isActive ? BUTTON_ACTIVE_BACKGROUND_COLOR_TRELLIS : undefined,
    children: [button, isActive && onValueChange && /*#__PURE__*/_jsx(IconButton, {
      "data-selenium-test": `QuickFiltersBar-item-${propertyName}-clear`,
      onClick: () => onValueChange(),
      size: "xs",
      use: "transparent",
      margin: "0",
      children: /*#__PURE__*/_jsx(RemoveIcon, {
        color: "icon-core-subtle"
      })
    })]
  });
};
export default QuickFilterSelectBase;